import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getDailyCashClosingByBranch } from '../../../../appRedux/actions';
import { stringDateTime } from '../../../../util/formatTime';
import { formatPrice } from '../../../../util/formatPrice';
import { Button, Table } from 'antd';
import { FileTextOutlined } from '@ant-design/icons';
import { dailyCashClosingConst } from '../../../../constants/DailyCashClosing';
import { UrlPaths } from '../../../../constants';
import { getFullName } from '../../../../util';

export const DailyCashClosingModal = ({ branchId, date }) => {
  const dispatch = useDispatch();
  const { dailyCashClosingByBranch } = useSelector(
    (state) => state.dailyCashClosing
  );

  const { filtersData } = useSelector((state) => state.generalStates);

  useEffect(() => {
    dispatch(
      getDailyCashClosingByBranch(branchId, {
        params: { ...filtersData, dates: `${date},${date}` },
      })
    );
  }, [dispatch, branchId, filtersData, date]);

  const columns = [
    {
      title: 'No',
      dataIndex: 'dailyCashClosingNumber',
      key: 'dailyCashClosingNumber',
    },
    {
      title: 'Sucursal',
      dataIndex: 'branch',
      key: 'branch',
      render: (branch) => branch?.name || '-',
      path: 'branch.name',
    },
    {
      title: 'Usuario',
      dataIndex: 'user',
      key: 'user',
      render: (user) =>
        user ? getFullName(user) : dailyCashClosingConst.AUTOMATIC,
      path: ['user.name', 'user.lastName', 'user.motherLastName'],
    },
    {
      title: 'Tipo',
      dataIndex: 'user',
      key: 'type',
      render: (user) =>
        user
          ? dailyCashClosingConst.MANUAL
          : dailyCashClosingConst.AUTOMATIC,
    },
    {
      title: 'Tarjeta de Crédito',
      dataIndex: 'creditCardTotal',
      key: 'creditCardTotal',
      render: (creditCardTotal) => `${formatPrice(creditCardTotal || '0')}`,
    },
    {
      title: 'Tarjeta de Débito',
      dataIndex: 'debitCardTotal',
      key: 'debitCardTotal',
      render: (debitCardTotal) => `${formatPrice(debitCardTotal || '0')}`,
    },
    {
      title: 'Efectivo',
      dataIndex: 'cashTotal',
      key: 'cashTotal',
      render: (cashTotal) => `${formatPrice(cashTotal || '0')}`,
    },
    {
      title: 'Puntos',
      dataIndex: 'pointsTotal',
      key: 'pointsTotal',
      render: (pointsTotal) => pointsTotal || '0',
    },
    {
      title: 'Dolares',
      dataIndex: 'cashTotalDollars',
      key: 'cashTotalDollars',
      render: (cashTotalDollars) => `${formatPrice(cashTotalDollars || '0')}`,
    },
    {
      title: 'Devoluciones',
      dataIndex: 'refundCash',
      key: 'refundCash',
      render: (refundCash, dailyCashClosing) =>
        `${formatPrice(
          refundCash ||
            0 + dailyCashClosing?.refundDebitCardTotal ||
            0 + dailyCashClosing?.refundCreditCardTotal ||
            0
        )}`,
    },
    {
      title: 'Total',
      dataIndex: 'total',
      key: 'total',
      render: (total) => `${formatPrice(total) || '0'}`,
    },
    {
      title: 'Fecha',
      dataIndex: 'created_at',
      key: 'created_at',
      render: (date) => stringDateTime(date),
      path: 'created_at',
      formatter: (date) => stringDateTime(date),
    },
    {
      title: 'Opciones',
      dataIndex: 'id',
      key: 'id',
      render: (id) => (
        <Button
          icon={<FileTextOutlined />}
          type="link"
          onClick={() => {
            window.open(
              UrlPaths.DAILY_CASH_CLOSING_TICKET(id),
              '_blank',
              'noopener,noreferrer'
            );
          }}
        />
      ),
    },
  ];

  return (
    <Table
      rowKey="id"
      dataSource={dailyCashClosingByBranch}
      columns={columns}
      scroll={{ x: dailyCashClosingConst.TABLE_SCROLL_WIDTH }}
      pagination={{
        defaultPageSize: 5,
        pageSizeOptions: [5, 10, 15],
      }}
    />
  );
};
